import globalConfig from '@utiles/officialStore/globalConfig';

const gameInfoConfig = {
  390: {
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'mudepwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialTopup/muglo/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialTopup/muglo/pwa-install-popup-btn.png'),
    pwaInstalledAward: require('@assets/image/officialTopup/muglo/pwa-installed-award.png'),
    bankTip: [] // 银行汇款提示，不填则使用默认值
  },
  402: {
    pwaAward: {
      open: false,
      activityName: ''
    },
    pwaInstallPopupBg: '',
    pwaInstallPopupBtn: '',
    pwaInstalledAward: '',
    bankTip: [
      '1、銀行虛擬帳號儲值只能進行通寶儲值哦',
      '2、匯款金額須與選擇金額保持一致才能正常獲取資源',
      '3、使用銀行匯款可能導致部分優惠無法使用，請以頁面實際顯示為準，如有疑問請諮詢客服'
    ]
  },
  191: {
    // 是否展示上线前弹窗
    isShowPreRightsPopup: true,
    offLineTime: '2025-06-26T00:00:00+00:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
        'zh-TW': '2025-06-26 00:00:00 (UTC)',
        'zh-CN': '2025-06-26 00:00:00 (UTC)',
        'vi-VN': '00:00:00 (UTC) ngày 26/06/2025',
        'tr-TR': '26/06/2025 00:00:00 (UTC)',
        'th-TH': '2025-06-26 เวลา 00:00:00 น.(UTC)',
        'ru-RU': '2025/06/26 00:00:00 (UTC)',
        'pt-PT': '26/06/2025 00:00:00 (UTC)',
        'pl-PL': '2025/06/26 00:00:00 (UTC)',
        'ko-KR': '2025-06-26 00:00:00(UTC)',
        'ja-JP': '2025 年 6 月 26 日 00:00:00(UTC)',
        'it-IT': '26/06/2025 00:00:00 (UTC)',
        'id-ID': '26/06/2025 00:00:00 (UTC)',
        'fr-FR': '26/06/2025 00:00:00 (UTC)',
        'es-ES': '26/06/2025 00:00:00 (UTC)',
        'en-US': '2025/06/26 00:00:00 (UTC)',
        'de-DE': '26.06.2025, 00:00:00 Uhr (UTC)',
        'ar-SA': '26-06-2025 00:00:00 (UTC)'
    },
    // 是否上线权益中心
    isOnlineRightsCenter: false,
    // 权益中心上线时间
    onlineRightsCenterTime: '', // 权益中心上线时间，需加上时区信息
    // 上线前弹窗链接
    preRightsPopupLink: '',
    // 权益中心链接
    rightsCenterLink: '',
  }
};

export const ZTMSLG_GAMES = [191, 225, 227, 284];
export const DTMSLG_GAMES = [285, 354, 355];

export const DOMAIN_MAP = {
  191: ['37games.com', 'pnsofficial.com', 'blancozone.com'], // 主版本游戏域名：需要包含分版本游戏域名
  225: ['blancozone.com'], // 分版本游戏域名
  227: ['blancozone.com'], // 分版本游戏域名
  284: ['37games.com', 'pnsofficial.com'], // 分版本游戏域名

  285: ['37games.com'], // 主版本游戏域名：需要包含分版本游戏域名
  354: ['blancozone.com'], // 分版本游戏域名
  355: [] // 分版本游戏域名，看到支付页管理后台没有配置，先空着
};

export const mergeGameDomainList = domainList => {
  const set = new Set(domainList);
  const gameId =
    globalConfig.getHrefParam('gameId') ||
    globalConfig.getHrefParam('gameID') ||
    globalConfig.getHrefParam('game_id') ||
    '';
  if (DOMAIN_MAP[Number(gameId)]) {
    DOMAIN_MAP[Number(gameId)].forEach(domain => {
      set.add(domain);
    });
  }
  return Array.from(set);
};

export default gameInfoConfig;
